import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
    PaymentElement,
    LinkAuthenticationElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import Spinner from 'react-bootstrap/Spinner';

import styles from "../CheckoutStyles.module.scss";
import { Link, useNavigate } from "react-router-dom";

import DotLoader from 'components/Utlility/DotLoader';
import StripeService from "../../services/stripe.service";

import StripeLogo from "images/stripe-blurple.svg";

export default function CheckoutForm(props) {
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();
    const { isLoggedIn, user } = useSelector(state => state.auth);

    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isStripeLoading, setIsStripeLoading] = useState(true);

    // Email edit state
    const [isEditingEmail, setIsEditingEmail] = useState(false);
    const [editedEmail, setEditedEmail] = useState(props.email || '');
    const [isSavingEmail, setIsSavingEmail] = useState(false);

    useEffect(() => {
        if (elements) {
            const element = elements.getElement('payment')
            element.on('ready', () => {
                setIsStripeLoading(false)
            })
            element.on('loaderror', () => {
                console.log("stripe load error")
            })
        }
    }, [elements])

    // Extract payment intent ID from clientSecret (format: pi_xxx_secret_yyy)
    const getPaymentIntentId = () => {
        if (props.clientSecret) {
            return props.clientSecret.split('_secret_')[0];
        }
        return null;
    };

    const handleSaveEmail = async () => {
        const paymentIntentId = getPaymentIntentId();
        if (!paymentIntentId) {
            console.error("No payment intent ID available");
            return;
        }

        setIsSavingEmail(true);
        try {
            await StripeService.updatePaymentIntentEmail(paymentIntentId, editedEmail);
            setIsEditingEmail(false);
        } catch (error) {
            console.error("Failed to update email:", error);
        }
        setIsSavingEmail(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsLoading(true);

        stripe.confirmPayment({
            elements,
            confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: `${window.location.origin}/checkout-return`,
                receipt_email: email,
            },
            redirect: "if_required"
        }).then((res) => {
            console.log("confirm payment res : ", res);
            if (res.paymentIntent) {
                navigate("/checkout-return?payment_intent=" + res.paymentIntent.id);
            } else {
                if (res.error) {
                    setMessage(res.error.message);
                }
                setIsLoading(false);
            }
        }).catch((error) => {
            if (error.type === "card_error" || error.type === "validation_error") {
                setMessage(error.message);
            } else {
                setMessage("An unexpected error occurred.");
            }

            setIsLoading(false);
        });
    };

    const paymentElementOptions = {
        layout: "tabs"
    }

    //const linkAuthenticationElementOptions = {
    //    defaultValues: {
    //        email: props.email
    //    }
    //};

    //const updateEmail = (event) => {
    //    setEmail(event.value.email);
    //}

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            {isStripeLoading && <DotLoader size="medium" variant="dark" />}
            {/*<LinkAuthenticationElement id="link-authentication-element" onChange={updateEmail} options={linkAuthenticationElementOptions} />*/}
            {props.email && (
                <div className={styles.emailReceipt}>
                    <span>Your receipt will be sent to:</span>
                    {isEditingEmail ? (
                        <div className={styles.emailEditRow}>
                            <input
                                type="email"
                                value={editedEmail}
                                onChange={(e) => setEditedEmail(e.target.value)}
                                className={styles.emailInput}
                            />
                            <button
                                type="button"
                                onClick={handleSaveEmail}
                                disabled={isSavingEmail}
                                className={styles.saveButton}
                            >
                                {isSavingEmail ? 'Saving...' : 'Save'}
                            </button>
                        </div>
                    ) : (
                        <div className={styles.emailDisplayRow}>
                            <strong>{editedEmail}</strong>
                            <button
                                type="button"
                                onClick={() => setIsEditingEmail(true)}
                                className={styles.editButton}
                            >
                                Edit
                            </button>
                        </div>
                    )}
                </div>
            )}
            <PaymentElement className={styles.paymentElement} id="payment-element" options={paymentElementOptions} />
            {message && <div className={styles.paymentMessage} id="payment-message">{message}</div>}
            {
                !isStripeLoading &&
                <button className={`${styles.button} mt-3`} disabled={isLoading || !stripe || !elements} id="submit">
                    {isLoading ? <div className={styles.spinner} id="spinner"></div> : "Pay now"}
                </button>
            }
            <br/>
            <img className="mt-2" src={StripeLogo} style={{ width: "175px" }} />
            {/* Show any error or success messages */}
            <p className="mt-2">
                By continuing you are agreeing to the <Link to="/terms">Game.City Terms</Link>
            </p>
        </form>
    );
}